<label class="container" [ngClass]="{ active: value }">
  <input [formControl]="control" id="{{ id }}" type="checkbox" />
  @if (value) {
    @if (type === 'square') {
      <app-icon [icon]="iconCheckActive"></app-icon>
    } @else if (type === 'square-frame') {
      <app-icon [icon]="iconCheckFrameActive"></app-icon>
    } @else {
      <app-icon [icon]="iconCheckRoundActive"></app-icon>
    }
  } @else {
    @if (type === 'square' || type === 'square-frame') {
      <app-icon [icon]="iconCheckEmpty"></app-icon>
    } @else {
      <app-icon [icon]="iconCheckRoundEmpty"></app-icon>
    }
  }

  @if (label) {
    <p>{{ label }}</p>
  }
</label>
